export default __webpack_public_path__ + "static/media/524478.ba34d9b4.jpg";